import { z } from 'zod';

export const zodInvoiceV2FilterOptionSuggestionsQueryParamsSchema = z.object({
  limit: z.number().int().min(1).max(50).optional(),
  searchString: z.string().trim().optional(),
});

export const zodInvoiceV2FilterOptionSchema = z.object({
  id: z.uuid(),
  name: z.string().nullish(),
});

export const zodInvoiceV2FilterOptionSuggestionsResponseSchema = z.object({
  data: z.array(zodInvoiceV2FilterOptionSchema),
});
